import React from 'react'
import i18n from '@dhis2/d2-i18n'
import { Title } from './Title'

export const TitleResource = () => <Title label={i18n.t('Resource')} />



// WEBPACK FOOTER //
// ./src/pages/resource/add-edit-resource/ResourceForm/TitleResource.js